import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Mail, Phone as PhoneIcon, Users } from "lucide-react";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  const filtered = customers.filter((c) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      (c.name || "").toLowerCase().includes(s) ||
      (c.email || "").toLowerCase().includes(s) ||
      (c.phone || "").toLowerCase().includes(s)
    );
  });

  return (
    <div data-testid="admin-customers">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-3xl tracking-tight">Customers</h1>
        <div className="mono-label text-white/50 flex items-center gap-2">
          <Users className="h-4 w-4"/> {customers.length} total
        </div>
      </div>

      <div className="relative mb-5">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40"/>
        <Input
          data-testid="customer-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name, email or mobile..."
          className="pl-9 bg-zinc-950 border-white/10 focus-visible:ring-blue-600"
        />
      </div>

      <div className="border border-white/10 bg-zinc-950 overflow-hidden">
        {filtered.length === 0 ? (
          <div className="p-10 text-center text-white/50 text-sm">
            {customers.length === 0 ? "No customers have signed in yet." : "No customers match your search."}
          </div>
        ) : (
          <div className="divide-y divide-white/10">
            {filtered.map((c) => (
              <div key={c.id} data-testid={`customer-${c.id}`} className="p-4 grid gap-3 sm:grid-cols-[1fr,auto] items-center">
                <div>
                  <p className="font-display text-lg">{c.name || <span className="text-white/40">— no name —</span>}</p>
                  <div className="mt-1 flex flex-wrap gap-4 text-xs text-white/60">
                    {c.email && <span className="flex items-center gap-1.5 font-mono"><Mail className="h-3 w-3"/>{c.email}</span>}
                    {c.phone && <span className="flex items-center gap-1.5 font-mono"><PhoneIcon className="h-3 w-3"/>{c.phone}</span>}
                  </div>
                </div>
                <div className="text-right">
                  <p className="mono-label text-white/40">Joined</p>
                  <p className="text-xs text-white/70 font-mono mt-1">
                    {c.created_at ? new Date(c.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—"}
                  </p>
                  {c.last_seen && c.last_seen !== c.created_at && (
                    <p className="text-[10px] text-white/40 font-mono mt-1">
                      Last seen {new Date(c.last_seen).toLocaleDateString("en-IN")}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
